export default "__VITE_ASSET__CCSGPvuE__"